export default __webpack_public_path__ + "static/anna-koteja-a5b75815e045c33eae88a97388c1c491.jpg";